/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} History_Log_TitleInputs */

const en_history_log_title = /** @type {(inputs: History_Log_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log a cook`)
};

const de_history_log_title = /** @type {(inputs: History_Log_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gekocht eintragen`)
};

/**
* | output |
* | --- |
* | "Log a cook" |
*
* @param {History_Log_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const history_log_title = /** @type {((inputs?: History_Log_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<History_Log_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_history_log_title(inputs)
	return en_history_log_title(inputs)
});